import React from "react";
import { caseStudies } from "../data";

// Rendered by Home.js only when caseStudies has entries.
export default function CaseStudies() {
  return (
    <section id="case-studies" className="bg-purple-900 text-white">
      <div className="container px-5 py-16 mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold title-font text-white mb-4">
            Case Studies
          </h1>
          <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-purple-200">
            Real engagements, real outcomes: the problems we were brought in
            to solve and what changed as a result.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {caseStudies.map((study) => (
            <div
              key={study.title}
              className="bg-purple-800 border border-purple-700 rounded-xl p-8 flex flex-col h-full"
            >
              <p className="text-purple-300 text-xs uppercase tracking-widest font-semibold mb-3">
                {study.segment}
              </p>
              <h2 className="text-white text-xl title-font font-medium mb-3">
                {study.title}
              </h2>
              <div className="flex flex-wrap gap-1.5 mb-4">
                {study.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs bg-purple-900 text-purple-100 border border-purple-700 rounded-full px-2 py-0.5"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <p className="text-purple-200 text-sm leading-relaxed mt-auto">
                <span className="text-white font-semibold">Outcome: </span>
                {study.outcome}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
